import { useCallback } from 'react';
import { isEmpty } from 'lodash-es';
import { useLocation } from '@namespace/i18n';
import { useHistory } from '@namespace/router';

export const useCustomCategoriesHandlePageChange = ({
  plexRequestPageSize,
  isFavoriteCategory,
  loadCategoryGames,
  categoryGameIds
}) => {
  const { replace } = useHistory();
  const { pathname } = useLocation();

  const handlePageChange = useCallback(
    async (newPage) => {
      replace(`${pathname}?page=${newPage}`);

      const nextGamesIds = categoryGameIds.slice(
        plexRequestPageSize * (newPage - 1),
        plexRequestPageSize * (newPage - 1) + plexRequestPageSize
      );

      if (isEmpty(nextGamesIds)) {
        return;
      }

      await loadCategoryGames({
        offset: 0,
        limit: plexRequestPageSize,
        [isFavoriteCategory ? 'id' : 'launchId']: nextGamesIds,
        dontUseGamesStorage: isFavoriteCategory
      });
    },
    [
      replace,
      categoryGameIds,
      loadCategoryGames,
      plexRequestPageSize,
      isFavoriteCategory
    ]
  );

  return handlePageChange;
};
